export const clearList = (htmlString?: string) => {
  // return (
  //   htmlString
  //     .match(/<li>(.*?)<\/li>/g)
  //     ?.map((item) => item.replace(/<\/?[^>]+>/g, ''))
  //     .filter((el) => el !== null) ?? []
  // )

  const parser = new DOMParser()

  if (htmlString) {
    return [
      ...parser
        .parseFromString(htmlString, 'text/html')
        .getElementsByTagName('ul')[0]
        .getElementsByTagName('li'),
    ].map((el) => el.innerHTML)
  } else return []
}
